import { CheckboxOptCustom } from '../checkbox-opt-custom';

import { formatCurrency } from 'utils/CurrencyUtils';
import { toppingSortedByParentId } from 'shared/utils/orders';

import makeClasses from './ToppingsByParentId.style';

import type { ToppingInOrderDetail } from 'shared/domain';

export function ToppingsByParentId(props: Props) {
  const { toppings } = props;

  const toppingsSorted = toppingSortedByParentId(toppings);

  const _classes = makeClasses();

  return (
    <ul
      aria-label='topping-list'
      data-toppings-level={0}
      className={_classes.toppingList}
    >
      {toppingsSorted.map((topping, idx) => (
        <ToppingItem
          nextLevel={1}
          topping={topping}
          key={`${topping.id}-${idx}`}
          previousName={toppingsSorted[idx - 1]?.name ?? ''}
        />
      ))}
    </ul>
  );
}

interface Props {
  toppings: Array<ToppingInOrderDetail>;
}

function ToppingItem(props: ToppingItemProps) {
  const { topping, nextLevel, previousName } = props;
  const showCategoryName = topping.name !== previousName;
  const _classes = makeClasses();
  return (
    <li
      key={topping.toppingNodeId}
      className={_classes.topping}
      data-topping-id={topping.id}
      data-topping-node-id={topping.toppingNodeId}
    >
      {showCategoryName && <h3 aria-label='category-name'>{topping.name}</h3>}
      <CheckboxOptCustom
        fullWidth={true}
        value='topping'
        name={topping.toppingNodeId.toString()}
        label={
          <>
            <div className={_classes.toppingInfo}>
              <p>{`${topping.units}x ${topping.description}`}</p>
              <p>{formatCurrency(topping.price.real)}</p>
            </div>
            {topping.children.length > 0 && (
              <ul
                aria-label='topping-list'
                data-toppings-level={nextLevel}
                className={_classes.toppingList}
              >
                {topping.children.map((childTopping, idx) => (
                  <ToppingItem
                    key={`${childTopping.id}-${idx}`}
                    nextLevel={nextLevel + 1}
                    topping={childTopping}
                    previousName={topping.children[idx - 1]?.name ?? ''}
                  />
                ))}
              </ul>
            )}
          </>
        }
      />
    </li>
  );
}

interface ToppingItemProps {
  nextLevel: number;
  topping: ToppingInOrderDetail;
  previousName: ToppingInOrderDetail['name'];
}
